<template>
    <div class="v2-retailer-cart__brand-product">
        <router-link
            :to="`/catalog/product/${item.ItemID}`"
            class="v2-retailer-cart__brand-product-logo"
        >
            <img
                :src="item.images[0].url"
                alt
                class="v2-retailer-cart__brand-product-img ofi"
            />
        </router-link>
        <div class="v2-retailer-cart__brand-product-descr">
            <div class="v2-retailer-cart__brand-product-descr-left">
                <div class="v2-retailer-cart__brand-product-brand">
                    {{ item.brand.BrandName }}
                </div>
                <div class="v2-retailer-cart__brand-product-text">
                    {{ item.Category_src }}
                </div>
                <div
                    class="v2-retailer-cart__brand-product-text v2-retailer-cart__brand-product-text--gray mb-2"
                >
                    Арт. {{ item.Article }}
                </div>
                <div class="v2-retailer-cart__brand-product-text">
                    {{
                        isInteger(+item.Price)
                            ? (+item.Price).toFixed()
                            : (+item.Price).toFixed(2)
                    }}
                    ₽/шт
                </div>
            </div>
            <div class="v2-retailer-cart__brand-product-descr-right">
                <div class="v2-retailer-cart__brand-product-addtocart">
                    <div
                        class="cabinet__catalog-form_minus disabled"
                        @click="item.qty > 1 ? lessQty(item.ItemID) : null"
                    ></div>
                    <span
                        class="cabinet__catalog-form_input cabinet__catalog-form_input--new cabinet-form-group__input"
                        >{{ item.qty }}</span
                    >
                    <div
                        class="cabinet__catalog-form_plus"
                        @click="moreQty(item.ItemID)"
                    ></div>
                </div>
                <div class="v2-retailer-cart__brand-product-summary">
                    {{
                        isInteger(item.Price * item.qty)
                            ? (item.Price * item.qty).toFixed()
                            : (item.Price * item.qty).toFixed(2)
                    }}
                    ₽
                </div>
            </div>
            <div class="v2-retailer-cart__brand-product-descr-bottom">
                <a
                    v-if="!isAddComment"
                    href="javascript:void(0)"
                    class="v2-retailer-cart__brand-product-link"
                    @click="isAddComment = true"
                    >Добавить комментарий</a
                >
                <div
                    v-if="isAddComment"
                    class="cabinet-form-group mt-0 mb-md-3"
                >
                    <label class="cabinet-form-group__label" for="message"
                        >Комментарий</label
                    >
                    <textarea
                        id="message"
                        v-model="comment"
                        class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable v2-retailer-cart__brand-product-textarea"
                        @change="setComment(item)"
                    ></textarea>
                    <div
                        class="cabinet-form-group__textarea-chars js-chars-count"
                    >
                        <span>0</span>/255
                    </div>
                </div>
                <a
                    href="javascript:void(0)"
                    class="v2-retailer-cart__brand-product-link"
                    @click="deleteItem(item.ItemID)"
                    >Удалить из заказа</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BrandProduct',

    props: {
        item: {
            type: Object
        }
    },

    data() {
        return {
            isAddComment: false,
            comment: ''
        }
    },

    created() {
        if (this.item.comment) {
            this.comment = this.item.comment

            this.isAddComment = true
        }
    },

    methods: {
        deleteItem(id) {
            this.$emit('deleteItem', id)
        },
        lessQty(id) {
            this.$emit('lessQty', id)
        },
        moreQty(id) {
            this.$emit('moreQty', id)
        },
        setComment(item) {
            const comment = this.comment

            this.$emit('setComment', { item, comment })
        },
        isInteger(num) {
            return (num ^ 0) === num
        }
    }
}
</script>
